import React, { Component, useState } from 'react'
import QrReader from 'react-qr-reader'
import './styles.scss'
import { QRScannerProps } from './types'

const QRScanner: React.FunctionComponent<QRScannerProps> = (props) => {
    const [result, setResult] = useState("");

    const handleScan = (data: any) => {
        if (data) {
            setResult(data);
            props.onScan(data);
        }
    }
    
    const handleError = (err: any) => {
        console.error(err)
    }

    return (
        <div className="qr-container">
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            className="qr-scanner"
          />
          <p>{result}</p>
        </div>
      )
}

export default QRScanner